import email from "../assets/email.png";
import full from "../assets/full.png";

import bg from "../assets/bg.svg";
import panel from "../assets/panel.svg";
import profile from "../assets/profile.png";


import logo from "../assets/logo.png";

export default {
  profile,
  bg,
  full,
  panel,
  email,
  logo,
};
